/*
 * Purpose: API base URL for local webhook server (Gmail inbound)
 * Last modified: 2026-06-25 | Agent
 * Completeness: 95
 */

/** Browser: same-origin /api (Vite proxy) or VITE_INBOUND_API_URL / VITE_API_URL for Cloudflare Worker. */
export function getApiBase(): string {
  const inbound = import.meta.env.VITE_INBOUND_API_URL as string | undefined;
  const legacy = import.meta.env.VITE_API_URL as string | undefined;
  const env = inbound || legacy;
  if (env) return env.replace(/\/$/, '');
  if (typeof window !== 'undefined') return '';
  return 'http://localhost:3001';
}

export function isRemoteInboundApi(): boolean {
  return Boolean(import.meta.env.VITE_INBOUND_API_URL || import.meta.env.VITE_API_URL);
}

export function gmailWebhookPostUrl(inboxId: string): string {
  return `${getApiBase()}/api/webhooks/gmail/${inboxId}`;
}

export function gmailWebhookLatestUrl(inboxId: string): string {
  return `${getApiBase()}/api/webhooks/gmail/${inboxId}/latest`;
}
